import VueRouter from 'vue-router';
import createHomeRouter from './modules/home';
import { addNavigatoinGuard } from './navigation-guard';

const router = new VueRouter({
  routes: createHomeRouter(),

  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

Promise.all([
  import(/* webpackChunkName: "dynamic-router" */ './modules/login'),
  import(/* webpackChunkName: "dynamic-router" */ './modules/market'),
  import(/* webpackChunkName: "dynamic-router" */ './modules/credit'),
  import(/* webpackChunkName: "dynamic-router" */ './modules/draw'),
  import(/* webpackChunkName: "dynamic-router" */ './modules/repay'),
  import(/* webpackChunkName: "dynamic-router" */ './modules/others'),
  import(/* webpackChunkName: "dynamic-router" */ './modules/contract'),
  import(/* webpackChunkName: "dynamic-router" */ './modules/new-redirect'),
  import(/* webpackChunkName: "dynamic-router" */ './modules/transfer'),
]).then((routerGenerators) => {
  routerGenerators.forEach((defaultExport) => {
    const {
      default: createRouter,
    } = defaultExport;

    router.addRoutes(createRouter(router));
  });
});

export default addNavigatoinGuard(router);
